import './index.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { initServices } from '~/services';

import { store, persistedStore } from './store';
import App from './App';

initServices(store);

const container = document.getElementById('root');
const root = createRoot(container);

// FIXME: I disabled it because it leads to 2 renders (for development mode) and have some chart's issue
//  will investigate it in the next iteration
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
            <App />
        </PersistGate>
    </Provider>
    // </React.StrictMode>
);
